<template>
  <div>
    <b-sidebar
      id="sidebar-product"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-product-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-3" v-else>
          <label class="ml-2">รายการสินค้า</label>
          <div class="mt-3 p-2 detail-panel">
            <div class="mx-2 d-flex">
              <b-input-group class="panel-input-border">
                <b-form-input
                  id="product-search"
                  class="input-serach rounded-circle"
                  placeholder="ค้นหา"
                  @keypress="handlePushMessage"
                  v-model="filter.search"
                ></b-form-input>
              </b-input-group>
              <b-button
                class="search-circle-bth"
                :style="$store.state.backgroundSecondary"
                ><span class="icon-input m-auto pr-2 text-white">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="searchProduct"
                  /> </span
              ></b-button>
            </div>
          </div>
          <b-row class="mx-0">
            <b-col
              class="px-0 py-1 tab-product text-center pointer"
              :style="
                tabCurrent == 1
                  ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                  : ''
              "
              @click="selectTab(1)"
            >
              <p>ทั้งหมด</p>
              <p>({{ totalProduct + totalSpa }})</p>
            </b-col>
            <b-col
              v-if="booth"
              class="px-0 py-1 tab-product text-center pointer"
              :style="
                tabCurrent == 2
                  ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                  : ''
              "
              @click="selectTab(2)"
            >
              <p>สินค้า</p>
              <p>({{ totalProduct }})</p>
            </b-col>
            <b-col
              v-if="spa"
              class="px-0 py-1 tab-product text-center pointer"
              :style="
                tabCurrent == 3
                  ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                  : ''
              "
              @click="selectTab(3)"
            >
              <p>บริการและสปา</p>
              <p>({{ totalSpa }})</p>
            </b-col>
          </b-row>
          <b-row
            class="mx-0 py-2 border-bottom"
            v-for="(product, index) in tabCurrent == 1
              ? productList.all
              : tabCurrent == 2
              ? productList.booth
              : productList.spa"
            :key="index"
          >
            <b-col
              cols="2"
              class="d-flex justify-content-center align-items-center"
            >
              <b-form-checkbox
                v-model="productSelect"
                :value="product.barcode"
              ></b-form-checkbox>
            </b-col>
            <b-col cols="7" class="px-2">
              <p>
                <strong>{{ product.barcode }}</strong>
              </p>
              <p class="text-sub">{{ product.name }}</p>
            </b-col>
            <b-col cols="3" class="px-2"
              ><p class="float-right text-nowrap">
                {{ product.price | numeral("0,0.00") }}
              </p></b-col
            >
          </b-row>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.page"
              :total-rows="
                tabCurrent == 1
                  ? totalProduct + totalSpa
                  : tabCurrent == 2
                  ? totalProduct
                  : totalSpa
              "
              :per-page="5"
              class="m-md-0 page-item"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div class="mb-4 w-100">
            <b-button
              :disabled="!productSelect"
              class="radius-btn text-white w-75"
              :style="$store.state.backgroundSecondary"
              @click="selectProduct"
              ><span>เลือก</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideProduct",
  components: { OtherLoading, InputText },
  props: {
    booth: {
      type: Boolean,
      isRequired: true,
    },
    spa: {
      type: Boolean,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      filter: {
        search: "",
        type: 0,
        page: 1,
      },
      productSelect: "",
      productList: {
        all: [],
        booth: [],
        spa: [],
      },
      totalProduct: 0,
      totalSpa: 0,
      tabCurrent: 0,
      isLoading: false,
    };
  },
  //   watch: {
  //   },
  methods: {
    async show() {
      this.tabCurrent = 1;
      this.showSlide = true;
      this.isLoading = true;
      await this.searchProduct();
      this.isLoading = false;
    },
    hide() {
      this.showSlide = false;
      this.productSelect = "";
      this.filter.page = 1;
    },
    async searchProduct() {
      let body = {
        articleType: "",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.filter.search,
        skip: (this.filter.page - 1) * 5,
        take: 5,
        spa: this.spa,
        booth: this.booth,
      };
      await this.axios
        .post(`${this.$baseUrl}/product/search_product`, body)
        .then((data) => {
          if (data.result == 1) {
            this.productList.all = data.detail;
          }
        });
      if (this.booth) {
        body.articleType = "ZFIN";
        await this.axios
          .post(`${this.$baseUrl}/product/search_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.productList.booth = data.detail;
              this.totalProduct = data.total_count;
            }
          });
      }
      if (this.spa) {
        body.articleType = "ZPACK";
        await this.axios
          .post(`${this.$baseUrl}/product/search_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.productList.spa = data.detail;
              this.totalSpa = data.total_count;
            }
          });
      }
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchProduct();
      }
    },
    selectTab(tab) {
      this.tabCurrent = tab;
      this.pagination(1);
    },
    pagination(Page) {
      this.filter.page = Page;
      this.searchProduct();
    },
    async selectProduct() {
      let body = {
        user_guid: this.$cookies.get("user_guid"),
        barcode: this.productSelect,
        product_id: [],
      };
      await this.$emit("onSelectProduct", body);
      this.hide();
    },
  },
};
</script>

<style scoped>
.tab-product {
  color: #fff;
  background-color: #dedede;
  border-bottom: 5px solid #dedede;
}
</style>
